import { render, staticRenderFns } from "./cadastroSignatario.vue?vue&type=template&id=3b550a40&scoped=true&"
import script from "./cadastroSignatario.vue?vue&type=script&lang=js&"
export * from "./cadastroSignatario.vue?vue&type=script&lang=js&"
import style0 from "./cadastroSignatario.vue?vue&type=style&index=0&id=3b550a40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b550a40",
  null
  
)

export default component.exports